import store from '@/store'

export default [
  {
    path: '/thesis-topics',
    name: 'thesis-topic',
    meta: { requiresAuth: true },
    component: () => import('@/pages/thesis-topic/index.vue')
  },
  {
    path: '/thesis-topics/:id',
    name: 'thesis-topic-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/thesis-topic/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('thesisTopic/find', to.params.id)
      next()
    }
  }
]
